export type PopoverPlacementType =
    | "center"
    | "top"
    | "top-start"
    | "top-end"
    | "bottom"
    | "bottom-start"
    | "bottom-end"
    | "left"
    | "left-start"
    | "left-end"
    | "right"
    | "right-start"
    | "right-end";

export type PopoverPlacementPositionType = "top" | "bottom" | "left" | "right";

export type PopoverPlacementAlignType = "start" | "end" | "center";

export interface PopoverDimensions {
    left: number;
    top: number;
    width: number;
    height: number;
    placement: PopoverPlacementType;
}

export interface PopoverOptions {
    safeMargin: number;
    viewportWidth: number;
    viewportHeight: number;
    offsetFromTarget: number;
}
